export default __webpack_public_path__ + "media/color/btcd-1330856d.svg";